export default {"src":"/_next/static/media/ic_phone.fa91d653.svg","height":20,"width":20};